export default [
  {
    path: '/app/interviews',
    name: 'Interviews',
    component: () => import('@/views/Admin/Interviews/Index.vue'),
    meta: {
      pageTitle: 'Görüşmeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_INTERVIEW_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/interviews/customer-search',
    name: 'InterviewCustomerSearch',
    component: () => import('@/views/Admin/Interviews/CustomerSearch.vue'),
    meta: {
      pageTitle: 'Görüşmeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/interviews',
          active: false,
        },
        {
          text: 'Müşteri Arama',
          active: true,
        },
      ],
      resource: 'ADMIN_INTERVIEW_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/interviews/add/:id_customers',
    name: 'InterviewAdd',
    component: () => import('@/views/Admin/Interviews/Add.vue'),
    meta: {
      pageTitle: 'Görüşmeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/interviews',
          active: false,
        },
        {
          text: 'Müşteri Arama',
          to: '/app/interviews/customer-search',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_INTERVIEW_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/interviews/view/:id',
    name: 'InterviewView',
    component: () => import('@/views/Admin/Interviews/View.vue'),
    meta: {
      pageTitle: 'Görüşmeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/interviews',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_INTERVIEW_VIEW',
      action: 'read',
    },
  },
]
